import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Pagination } from 'src/app/core/models/pagination.model';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-user-filter',
  templateUrl: './user-filter.component.html',
  styleUrls: ['./user-filter.component.css']
})
export class UserFilterComponent {

  @Input()
  pagination: Pagination;
  searchBox = new FormControl();
  activeSwitch = 'active';

  @Output()
  onSearch = new EventEmitter<string>();

  @Output()
  onActiveFilter = new EventEmitter<string>();

  get allItems() {
    return this.pagination.totalItems;
  }

  constructor() {
    this.searchBox
      .valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged()
      ).subscribe(term => {
        this.onSearch.emit(term);
      });
  }

  activeFilterChange(activeFilter: string) {
    this.activeSwitch = activeFilter;
    this.onActiveFilter.emit(activeFilter);
  }

}
